import styles from "./InfoItem.module.css";

type ComponentProps = {
  children?: React.ReactNode;
  label?: string;
  value?: string;
};

export const InfoItem = ({ children, label, value }: ComponentProps) => (
  <div className={styles.item}>{label ? <>{label}: <strong>{value}</strong></> : <>{children}</>}</div>
);
